import script from "./DurataTable3.vue?vue&type=script&setup=true&lang=js"
export * from "./DurataTable3.vue?vue&type=script&setup=true&lang=js"

import "./DurataTable3.vue?vue&type=style&index=0&id=b3b839ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3b839ac"]])

export default __exports__